import { apiClient } from "./apiClient";

export interface NotificationPreference {
  category: string;
  labelKey: string;
  descriptionKey: string;
  email: boolean;
  push: boolean;
  dismissable: boolean;
}

export async function getNotificationPreferences(): Promise<
  NotificationPreference[]
> {
  const res = await apiClient.get<NotificationPreference[]>(
    "/auth/me/notification-preferences",
  );
  return res.data;
}

export async function updateNotificationPreferences(
  preferences: { category: string; email?: boolean; push?: boolean }[],
): Promise<void> {
  await apiClient.patch("/auth/me/notification-preferences", { preferences });
}
